// Editor panel for logged-in TYPO3 backend users, provided by Pagepilot
// (github.com/dbraendle/pagepilot). Only Pagepilot's tiny entry ships in the
// main bundle; the panel itself is a lazy chunk loaded for editors only.

import './admin-panel-base.scss';
import { init } from 'pagepilot';
import config from './config.js';

export default {
    init() {
        init(config);
    }
};
